var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state === 'loading')?_c('AudioToolLoading'):_c('div',{staticClass:"max-w-lg w-full mx-auto"},[_c('div',{staticClass:"text-center w-full h-auto"},[_c('p',{staticClass:"text-base text-red-700",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.error)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }